import { Outlet } from "react-router-dom"

import LanguageChooser from "components/language-chooser"
import Logo from "components/logo"

import LoginImage from "assets/loginPage.jpg"

import styles from "./styles.module.scss"

const AuthLayout: React.FC = ({ children }) => {
  return (
    <div className={styles.loginPage}>
      <aside>
        <img src={LoginImage} alt="Login" />
      </aside>
      <div className={styles.mainContent}>
        <main>
          <Outlet />
        </main>
        <footer>
          <LanguageChooser size="small" />
        </footer>
      </div>
    </div>
  )
}

export const Header: React.FC = ({ children }) => {
  return (
    <header>
      <Logo />
      <h1 className="headline-heavy">{children}</h1>
    </header>
  )
}

export const Subtitle: React.FC = ({ children }) => {
  return <p className={`${styles.subTitle} body`}>{children}</p>
}

export default AuthLayout
